<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Export</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body" style="

">
  <div class="SelectArea">

    <div class="row" *ngFor="let koop of Entrys()">
      <div class="col">
        <div class="form-check mb-3">
          <input id="Partner{{koop.key}}" class="form-check-input" type="radio" name="IDs" [value]="koop.key"  [checked]="this.selected == koop.key" (change)="addOrRemoveID(koop.key)" />
          <label for="partner{{koop.key}}" class="form-check-label">{{koop.name}}</label>
        </div>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col"></div>
    <div class="col-auto"><div class="btn btn-primary" (click)="Export()">Export</div></div>
  </div>
</div>
